// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".credits-block[data-v-54b1805b]{font-family:\"Brown\",serif}h4[data-v-54b1805b]{font-size:1.2em !important;text-transform:uppercase;margin-bottom:.5em}.name[data-v-54b1805b]{font-family:\"Roboto Slab\",serif}", ""]);
// Exports
module.exports = exports;
